import React from 'react';
import { intl } from '@corti/i18n';
import { rbacService } from 'browser/services/init';
import { FallbackView } from 'lib/cortiUI';
import { NotificationsView } from './NotificationsModule/NotificationsView';
export function HomeView() {
    return (React.createElement(React.Fragment, null, rbacService.appInbox() ? (React.createElement(NotificationsView, null)) : (React.createElement(FallbackView, { title: intl.t('home:noPermission.title', 'No permissions'), text: intl.t('home:noPermission.text', 'Please contact your system administrator') }))));
}
